module.exports = require("./../../_gen/openfl/filters/BitmapFilter");